// extracted by mini-css-extract-plugin
module.exports = {"product-search-refinement-rating-input-rating":"ProductSearchRefinementRatingInputRating_product-search-refinement-rating-input-rating__rFrM3"};